export default __webpack_public_path__ + "static/media/Glacier-Caves.2222c5b8.webp";